module.exports = __webpack_public_path__ + "static/media/volar-infinite.81ef1a43.png";